<template>
  <header id="home">
    <MainMenu />
    <MainBanner />
  </header>
</template>
<script>
import MainMenu from "./MainMenu";
import MainBanner from "./MainBanner";
export default {
  components: {
    MainMenu,
    MainBanner,
  },
};
</script>
